<div id="dept-chemistry" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Chemistry</h2>
    <p class="inner-lead mt-3">
      The Department of Chemistry at Shah Satnam Ji Girls' College, Sirsa provides a strong foundation in chemical sciences through well-equipped laboratories and experienced faculty. The department offers chemistry as part of B.Sc. (Non-Medical) and B.Sc. (Computer Science) programmes.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>B.Sc. (Non-Medical) — Chemistry as Core Subject</li>
      <li>B.Sc. (Computer Science) — Chemistry as Core Subject</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Payal Rani</td><td>M.Sc (Chemistry), B.Ed, Ph.D (Pursuing)</td></tr>
          <tr><td>2</td><td>Ms. Shifali</td><td>M.Sc (Chemistry), B.Ed</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>

    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>Global Handwashing Day — Participative activity</li>
      <li>World Science Day — Poster Making Competition</li>
      <li>Essay Writing Competition</li>
      <li>Field Trip (Outdoor)</li>
    </ul>

    <h5 class="section-subtitle-orange" style="font-size:1rem;">2022–23</h5>
    <ul class="inner-lead">
      <li>Gender Equality Workshop</li>
      <li>Field Visit to Paper Mill</li>
    </ul>

    <h5 class="section-subtitle-orange" style="font-size:1rem;">2021–22</h5>
    <ul class="inner-lead">
      <li>Poster Making and Essay Writing (Online)</li>
    </ul>

  </div>
</div>
